import React from 'react';
import App from '../App';

const ChatPage = () => {
    return <App />;
};

export default ChatPage;